import { render, staticRenderFns } from "./nopayOrder.vue?vue&type=template&id=109fd848&scoped=true"
import script from "./nopayOrder.vue?vue&type=script&lang=js"
export * from "./nopayOrder.vue?vue&type=script&lang=js"
import style0 from "./nopayOrder.vue?vue&type=style&index=0&id=109fd848&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109fd848",
  null
  
)

export default component.exports